export default __webpack_public_path__ + "static/media/whiteArrowRight.64519118.svg";